export default __webpack_public_path__ + "static/media/bci-3-hover.79079198.svg";